import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { imgUrl } from "@/api";

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export const Featured = ({ products, onOpen }) => {
  const featured = products.filter((p) => p.featured).slice(0, 2);
  const items = featured.length >= 2 ? featured : products.slice(0, 2);
  if (items.length === 0) return null;

  return (
    <section id="one-cikanlar" className="py-24 md:py-36" data-testid="featured-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div {...reveal} className="flex items-end justify-between mb-16 md:mb-24">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-500 mb-4">Seçki</p>
            <h2 className="font-serif font-light tracking-tight text-stone-800 text-3xl sm:text-4xl lg:text-5xl">
              Öne çıkan parçalar
            </h2>
          </div>
          <a href="#koleksiyon" data-testid="featured-view-all" className="hidden md:inline-flex items-center gap-2 link-underline text-xs font-semibold tracking-[0.2em] uppercase text-stone-600">
            Tümünü Gör <ArrowUpRight size={14} />
          </a>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          {items.map((p, i) => (
            <motion.article
              key={p.id}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.15 }}
              className={`group cursor-pointer ${i === 0 ? "md:col-span-7" : "md:col-span-5 md:mt-24"}`}
              onClick={() => onOpen(p)}
              data-cursor="Görüntüle"
              data-testid={`featured-product-${p.id}`}
            >
              <div className={`overflow-hidden bg-beige-soft ${i === 0 ? "aspect-[4/3]" : "aspect-[4/5]"}`}>
                <img
                  src={imgUrl(p.image_url)}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <div className="mt-6 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-stone-800 tracking-tight">{p.title}</h3>
                  <p className="text-sm text-stone-500 font-light mt-2 max-w-md leading-relaxed line-clamp-2">{p.description}</p>
                </div>
                <span className="mt-2 inline-flex h-10 w-10 shrink-0 items-center justify-center border border-stone-300 text-stone-600 transition-colors duration-300 group-hover:bg-stone-900 group-hover:text-stone-50 group-hover:border-stone-900">
                  <ArrowUpRight size={16} />
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
